import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement } from 'lit/decorators.js';

import componentStyles from './pc-insight-series.css.lit';
import '../pc-container/pc-container';

/**
 * Insight Series component
 * @element pc-insight-series
 * @slot - This element has a default slot
 */
@customElement('pc-insight-series')
export class PCInsightSeries extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];

  render(): TemplateResult {
    return html`
      <div class="insight-series">
        <pc-container>
          <div class="inner">
            <div class="left-side">
              <slot name="nav"></slot>
              <div class="content">
                <slot name="eyebrow"></slot>
                <slot name="title"></slot>
                <slot name="description"></slot>
                <slot name="cta"></slot>
              </div>
            </div>
            <div class="right-side">
              <slot name="blocks"></slot>
            </div>
          </div>
        </pc-container>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-insight-series': PCInsightSeries;
  }
}
